// extracted by mini-css-extract-plugin
export default {"titlePage":"permissionByApp_titlePage__D+Klv"};